import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect, useParams } from "react-router-dom";
import { connect } from "react-redux";
import classNames from "classnames";
import _ from "lodash";
import { setToken, logout } from "../modules/auth/Auth.ducks";
import { Header, Footer } from "./index";
import SplashScreen from "./SplashScreen";
import { PrivateComponentStyles } from "../styles/";
import { withStyles } from "@material-ui/core";
import {
  fetchAgent,
  getAbonnement,
} from "../components/compte/compte.ducks.js";
import jwt_decode from "jwt-decode";
import axios from "axios";
import { API } from "../const";

class PrivateRoute extends React.Component {
  static propTypes = {
    component: PropTypes.any,
    render: PropTypes.func,
    auth: PropTypes.object,
    location: PropTypes.object,
    classes: PropTypes.object,
    className: PropTypes.string,
  };
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      abonnement: null,
    };
    this.handleRedirect = this.handleRedirect.bind(this);
  }
  componentDidMount() {
    if (!this.props.auth.accessToken && window.localStorage.getItem("token")) {
      let token = localStorage.getItem("token");
      let tokenDecoded = token ? jwt_decode(token) : "";
      const response = axios.get(`${API}api/creche/abonnements`, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        },
      });
      response.then((res) => {
        console.log("abonnement privateRoutes webbbbbbb successs", res.data);

        let data = {
          dateEcheance: "2021-05-29T02:53:15+02:00",
          equipementFourni: true,
          equipements: "",
          statut: "NON_ABONNEE",
          type: "CRECHE_ANNUEL",
          urlAbonnement: "https://b",
        };
        this.setState({ abonnement: res.data, tokenDecoded });
      });
      response.catch((err) => {
        console.log("abonnement privateRoutes webbbbbbb erreur", err);
        let code =
          err.response && err.response.data ? err.response.data.code : null;
        console.log("abonnement privateRoutes webbbbbbb erreur Code ", code);

        let abonnement = code === 1007 ? { statut: "INCONNU" } : null;
        console.log(
          "abonnement privateRoutes webbbbbbb erreur abonnement",
          abonnement
        );

        this.setState({ abonnement: abonnement });
      });
      if (window.localStorage.getItem("first")) {
        this.setState({ isLoading: true });
      }

      this.props.setToken(window.localStorage.getItem("token"));
      if (tokenDecoded && process.env.NODE_ENV === "production") {
        this.props.fetchAgent(token, tokenDecoded.AGENT_ID);
        if (tokenDecoded.TYPE_COMPTE === "ADMIN_CRECHE") {
          this.props.getAbonnement(localStorage.getItem("token"));
        }
      }
    }
  }
  handleRedirect() {
    this.setState({ isLoading: false }, () =>
      console.log("handleRedirect ", this.state.isLoading)
    );
    window.localStorage.removeItem("first");
  }

  render() {
    const {
      component: Component,
      render,
      auth,
      classes,
      className,
      ...rest
    } = this.props;
    let { abonnement, tokenDecoded } = this.state;
    const authenticated =
      (auth && auth.accessToken) || window.localStorage.getItem("token");
    const rootClassName = classNames(classes.root, className);
    console.log("authenticated privateRoutes ", authenticated);
    console.log("abonnement privateRoutes ", abonnement);
    console.log("isLoading privateRoutes ", this.state.isLoading);
    return (
      <Route
        {...rest}
        render={(props) =>
          (authenticated && this.state.isLoading) ||
          (authenticated && abonnement && abonnement.statut !== "ACTIVE" && abonnement.statut !== "TRIALING") ? (
            <SplashScreen
              abonnement={abonnement}
              handleRedirect={this.handleRedirect}
            />
          ) : authenticated ? (
            <div className={rootClassName}>
              <div className={classes.mainComponent}>
                <Component {...props} />
              </div>
            </div>
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location },
              }}
            />
          )
        }
      />
    );
  }
}

const mapStateToProps = ({ auth }) => ({ auth });

const mapDispatchToProps = { setToken, logout, fetchAgent, getAbonnement };

const withStore = connect(mapStateToProps, mapDispatchToProps);

export default withStyles(PrivateComponentStyles)(withStore(PrivateRoute));
